import type { ProjectFile } from "@/graphql.ts";
import { FILE_BROWSE_TYPES } from "@/settings/settings.ts";

export const rootProjectFileData = {
  fileName: "",
  fullPath: "",
  id: 2,
  humanReadablePath: "",
  fileBrowseType: FILE_BROWSE_TYPES.ROOT,
  isEditable: false,
} satisfies Partial<ProjectFile>;
